export const getAdId = (sid: string): number => parseInt(sid.split('.')[0], 10);
